/// <reference types="gapi.client.drive" />

const metadata = {
	name: 'config.json',
	mimeType: 'application/json',
};

async function findFile() {
	return gapi.client.drive.files
		.list({
			spaces: 'appDataFolder',
			q: `name = '${metadata.name}'`,
			pageSize: 1,
			fields: 'nextPageToken, files(id, name)',
		})
		.then((response) => {
			return response.result.files && response.result.files.length === 1
				? response.result.files[0]
				: false;
		});
}

// eslint-disable-next-line @typescript-eslint/ban-types
function createBlobFromObject(dataObject: {}) {
	return new Blob([JSON.stringify(dataObject, null, 2)], {
		type: 'application/json',
	});
}

async function createFile() {
	console.log('Creating file...');
	const fileMetadata = { ...metadata, parents: ['appDataFolder'] };
	return gapi.client.drive.files
		.create({
			resource: fileMetadata,
		})
		.then((response) =>
			response.status === 200 ? response.result : new Error(String(response))
		);
}

async function getFileId(): Promise<string> {
	let file = await findFile();
	if (!file) {
		file = await createFile();
	}

	return file.id ? file.id : '';
}

async function getFile(): Promise<any> {
	console.log('Getting file...');
	const response = await gapi.client.drive.files.get({
		fileId: await getFileId(),
		alt: 'media',
	});
	if (response.status === 200) {
		console.log('Success!', response.result);
		return response.result;
	}

	console.log('error', response);
}

async function updateFileWithFile(file: Blob) {
	console.log('Updating file...');
	const form = new FormData();
	form.append('metadata', createBlobFromObject(metadata));
	form.append('file', file);
	return await fetch(
		`https://www.googleapis.com/upload/drive/v3/files/${await getFileId()}?uploadType=multipart&fields=id`,
		{
			method: 'PATCH',
			headers: new Headers({
				Authorization: 'Bearer ' + gapi.auth.getToken().access_token,
			}),
			body: form,
		}
	).then((response) => response.json());
}

async function updateFileWithObject(fileContent: any) {
	const file = createBlobFromObject(fileContent);
	return updateFileWithFile(file);
}

async function download() {
	const dataObject = await getFile();
	const file = createBlobFromObject(dataObject);
	const objectURL = URL.createObjectURL(file);
	const a = document.createElement('a');
	a.href = objectURL;
	a.download = metadata.name;
	a.click();
	setTimeout(() => {
		a.remove();
		URL.revokeObjectURL(objectURL);
	}, 0);
}

export { getFile, updateFileWithFile, updateFileWithObject, download };
